import { loadJSSVG } from "../../general/functions";

const generateStaging = function (staging) {

    let curLabel, curString;

    switch (staging) {
        case 'NEW':
            curLabel = ' label-light-success ';
            curString = 'NEW'
            break;
        case 'ACTIVE':
            curLabel = ' label-light-primary ';
            curString = 'ACTIVE'
            break;
        case 'INACTIVE':
            curLabel = ' label-light-danger ';
            curString = 'INACTIVE'
            break;
        case 'FINISHED':
            curLabel = ' label-light-info ';
            curString = 'FINISHED'
            break;
        case 'CLOSED':
            curLabel = ' label-light-warning ';
            curString = 'CLOSED'
            break;
        case 'CANCELED':
            curLabel = ' label-light-danger ';
            curString = 'CANCEL'
            break;
        case 'CANCEL':
            curLabel = ' label-light-danger ';
            curString = 'CANCEL'
            break;
        case 'COMPLETE':
            curLabel = ' label-light-warning ';
            curString = 'COMPLETE'
            break;
        case 'DONE':
            curLabel = ' label-light-dark ';
            curString = 'DONE'
            break;
        case 'OPEN':
            curLabel = ' label-light-dark ';
            curString = 'OPEN'
            break;

        /** Status untuk APPLICATION */
        case "CREATED":
            curLabel = " label-light-success border-success ";
            curString = "Created";
            break;

        case "DATA PENDING":
            curLabel = " label-light-danger border-warning text-success ";
            curString = "Document / Data Pending";
            break;

        case "FULL-OFFER":
            curLabel = " label-light-primary border-primary ";
            curString = "Full Offer";
            break;

        case "APPLIED":
            curLabel = " label-light-primary border-primary";
            curString = "Applied";
            break;

        case "VISA NOT APPLIED":
            curLabel = " label-light-info border-warning ";
            curString = "Visa Not Applied";
            break;

        case "PAID APPLICATION":
        case "CLOSING APPLICATION":
            curLabel = " label-light-warning border-warning text-warning";
            curString = "Paid Application Fee";
            break;

        case "PAID TUITION":
        case "CLOSING TUITION":
            curLabel = " label-light-warning border-warning text-warning";
            curString = "Paid Tuition Fee";
            break;

        case "PAID DEPOSIT":
            curLabel = " label-light-danger border-warning text-warning ";
            curString = "Paid ICAN Deposit";
            break;


        case "CONDITIONAL-OFFER":
            curLabel = " label-light-info border-info ";
            curString = "Conditional Offer";
            break;


        case "VISA PROCESS":
        case "VISA APPLIED":
            curLabel = " label-light-info border-info ";
            curString = "Visa Process";
            break;

        case "APPROVED":
        case "VISA APPROVE":
            curLabel = " label-light-info border-info ";
            curString = "Visa Approved";
            break;

        case "REJECTED":
            curLabel = " label-light-info border-info ";
            curString = "Visa Rejected";
            break;

        case "APPLICATION REJECTED":
            curLabel = " label-light-info border-danger ";
            curString = "Application Rejected";
            break;

        case "WITHDRAW":
            curLabel = " label-light-danger border-danger ";
            curString = "Withdraw";
            break;

        case "CANCEL":
            curLabel = " label-light-danger border-danger ";
            curString = "Cancel";
            break;


        default:
            curLabel = " label-light-danger border-danger ";
            curString = "Not Created";
            break;

    }

    return {
        label: curLabel,
        text: curString
    };

}

const formatPrograms = function (program) {

    let curProgram = '';
    let formattedProgram = '';

    // Split program
    if (program != null) {

        if (program.indexOf('-') !== false) {

            let progList = program.split(';');

            for (let i = 0; i < progList.length; i++) {
                curProgram += progList[i].split('-')[0] + ', ';
            }

        } else {
            curProgram = program;
        }

        formattedProgram = curProgram.trim().slice(0, -1) + '';

    } else {
        formattedProgram = '-';
    }


    return formattedProgram;
}

const formatSchool = function (school) {

    let schoolName = '';

    if (school.indexOf('-')) {
        let finalString = school.split('-')

        schoolName = finalString[0]
    } else {
        schoolName = finalString
    }

    return schoolName

}

const generateMobileNumber = function (number) {

    let formattedNumber = '-';

    if (number == '' || number == null || number == '-') {
        return formattedNumber;
    } else {

        // Hapus semua simbol
        let tmpNumber = number.replace(/[-+]/g, '');

        if (tmpNumber.substring(0, 1) == '8') {
            tmpNumber = '62' + tmpNumber;
        } else if (tmpNumber.substring(0, 2) == '08') {
            tmpNumber = '62' + tmpNumber.substring(1);
        }

        formattedNumber = `${tmpNumber}
        <a href="https://api.whatsapp.com/send?phone=${tmpNumber}" target="_blank">
          <span class="font-weight-bolder">${loadJSSVG['whatsapp-sm']}</span>
        </a>`;

    }

    return formattedNumber;
}


const checkValues = function (val) {
    if (val == '' || val == null || val == undefined) {
        return '-'
    }

    return val
}

const checkEmptyClass = function (val) {
    if (val == '' || val == null || val == undefined) {
        return 'd-none'
    }

    return ''
}

const checkAsssigned = function (row) {

    let admission = '', counsellor = '', visa = '', location = ''

    if (row.ADMISSION_NAME == 'NO_ADMISSION') {
        admission = 'Tidak Perlu';
    } else if (row.ADMISSION_NAME == '' || row.ADMISSION_NAME == null) {
        admission = 'NONE';
    } else {
        admission = row.ADMISSION_NAME;
    }

    if (row.COUNSELLOR_NAME == null || row.COUNSELLOR_NAME == '') {
        counsellor = 'NONE';
    } else {
        counsellor = row.COUNSELLOR_NAME;
    }

    if (row.VISA_STAFF == 'tidak_perlu') {
        visa = 'Tidak Perlu';
    } else if (row.VISA_STAFF == '' || row.VISA_STAFF == null) {
        visa = 'NONE';
    } else {
        visa = row.VISA_NAME;
    }

    if (row.SUB_COMPANY == null) {
        location = row.LOCATION_DESC;
    } else {
        location = `${row.LOCATION_DESC} <span class="text-muted">(${row.SUB_COMPANY})</span>`;
    }

    return {
        counsellor, admission, visa, location
    }
}


const checkDues = function (row) {

    // Cek tanggalnya
    const curDate = new Date();
    const taskDate = new Date(row.DATE_FROM);

    curDate.setHours(0, 0, 0, 0);
    taskDate.setHours(0, 0, 0, 0);

    // Details
    let curText = '', curClass = ''

    if (curDate.getTime() === taskDate.getTime()) {
        // Hari ini
        if (row.STATUS != 'COMPLETED') {
            curText = 'Due Today';
            curClass = ' label-light-primary ';
        } else {
            curText = 'Completed';
            curClass = ' label-light-success ';
        }
    } else if (curDate.getTime() > taskDate.getTime()) {
        // Udah lewat
        if (row.STATUS != 'COMPLETED') {
            curText = 'Missed Follow Up';
            curClass = ' label-light-danger ';
        } else {
            curText = 'Completed';
            curClass = ' label-light-success ';
        }
    } else if (curDate.getTime() < taskDate.getTime()) {
        // Belom lewat

        if (row.STATUS != 'COMPLETED') {
            curText = 'Incomplete';
            curClass = ' label-light-warning ';
        } else {
            curText = 'Completed';
            curClass = ' label-light-success ';
        }
    }

    return {
        curText, curClass
    }

}

export {
    generateStaging,
    generateMobileNumber,
    formatPrograms,
    formatSchool,
    checkValues,
    checkEmptyClass,
    checkAsssigned,
    checkDues
}